export default __webpack_public_path__ + "static/media/block-align-right.d1990b4e.svg";